<template>
  <section class="h-100 gwrap">
    <div class="container h-100">
      <div class="row h-100 justify-content-center">
         <div class="col-8 align-self-center" v-if="user">
            <div class="card card-block sel-card">
              <div class="card-body">
              <div class="text-center">
                <img src="/images/Scout_Logo.png" alt="logo" style="max-width:30%">
              </div>
              <h4 class="select-title text-center" v-if="type == 'first'">{{ $t('que-welcome') }}</h4>
              <h4 class="select-title text-center" v-if="type == 'change'">{{ $t('cal-change-proj') }}</h4>
              <h4 class="select-title text-center" v-if="type == 'completed'">{{ $t('Well done! Project is completed') }}</h4>
              <h5 class="card-title text-center" v-if="type == 'first'">{{ user.realname }}</h5>
              <p v-if="noproj" >{{ $t('cal-select-noaloc') }}</p>
              <form method="POST" class="my-login-validation" novalidate="">

                <div class="form-group row proj-listing" v-if="selProj">
                  <label for="projectList" class="col-sm-4 col-form-label text-right">{{ $t('cal-select-proj') }}</label>

                  <select v-model="selProj" class="col-sm-7 form-control" >
                    <option v-for="(pname, pid) in projects" v-bind:value="pid">
                      [{{pid}}] {{ pname }}
                    </option>
                  </select>

                </div>

                <div class="row">
                  <div class="col-sm">
                    <a class="btn btn-border" @click="doLogout" v-if="type == 'first' || type == 'completed'">{{ $t('cal-logout') }}</a>
                    <router-link to="/main" v-else class="btn btn-border" >{{ $t('jsur-cancel') }}</router-link>
                  </div>

                  <div class="col-sm" v-if="selProj">
                    <a href="#" class="btn btn-success btn-block" @click.prevent="selProject">{{ $t('cal-btn-start') }}</a>
                  </div>
                  <div class="col-sm" v-if="!selProj">
                    <a href="#" class="btn btn-primary btn-block" @click.prevent="fetchData">{{ $t('cal-btn-check') }}</a>
                  </div>
                  <div class="spinner-border text-primary" role="status" v-if="loading">
                    <span class="sr-only">{{ $t('cal-loading') }}</span>
                  </div>
                </div>

              </form>
            </div>
            </div>
         </div>
         <div class="col-sm" v-if="selProj" style="width:220px; position: absolute; bottom:20px; right: 20px">
                    <a href="#" class="btn btn-primary btn-block" @click.prevent="doSimulation">{{ $t('cal-btn-simulate') }}</a>
                  </div>
      </div>
    </div>
  </section>
</template>

<script>

import api from '@/api';
//kcuioi51skmor1kipco6d2flt2

export default {
  name: 'selectProj',
  data () {
    return {
      selProj: null,
      projects: [],
      user: null,
      type: null,
      noproj: false,
      loading: true
    }
  },
  created() {
    if(localStorage.getItem('langReload')) {
      localStorage.removeItem('langReload');
      location.reload();
    }
    let user = localStorage.getItem('user');
    if(!user) {
      this.$router.push('/');
    }
    this.user = JSON.parse(user);
    this.fetchData();
    this.type = this.$route.params.type || 'first';
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.noproj = false;
      let result = await api.get('/survey/interviewer/assign-ajax');
      this.loading = false;
      if(result.data.success) {
        this.projects = result.data.projects;
        if(result.data.projects) {
          if(this.$route.query.pid) {
            this.selProj = this.$route.query.pid;
          } else {
            this.selProj = Object.keys(this.projects)[0];
          }
        } else {
          this.noproj = true;
        }
      } else {
        this.doLogout();
      }
    },
    async doLogout() {
      localStorage.removeItem('user');
      let result = await api.get('/auth/index/logout');
      this.$router.push('/');
    },
    async selProject() {
      let result = await api.post('/survey/interviewer/assign-ajax/pid/'+this.selProj );
      if(result && result.data.success) {
        this.$router.push('/main');
      } else {
        notie.alert({ type: 'error', text: _t(result.data.error) });
      }
    },
    async doSimulation() {
      let result = await api.get('/survey/interviewer/to-simulate?pid='+this.selProj);
      if(result.data.redirect) {
        window.location.href = result.data.redirect;
      }
    },
    async selectProj() {

    }
  }
};
</script>
